export default __webpack_public_path__ + "static/media/StoryBrand-thumb-2.f29eb5cc.png";